module.exports = __webpack_public_path__ + "static/media/normal.9c04bacc.png";